<template>
  <div class="vldMain">
    <div class="vldIndMain" :style="{ 'background-color' : (vldValid ? '#21ff34' : '#ff2121') }"></div>
    <div class="vldInfoMain">
      <div class="vldInfoTitle">{{vldTitle}}</div>
      <div class="vldInfoValue">{{vldValue}}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    vldTitle: { type: String, default: '-' },
    vldValue: { type: String, default: '-' },
    vldValid: { type: Boolean, default: false },
  },
  mounted() {
  },
  methods: {
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.vldMain {
  width: 100%;
  height: 24px;
  padding: 0 2px;
  margin: 2px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vldIndMain {
  width: 22px;
  height: 22px;
  border: solid 1px #0004;
  border-radius: 100%;
}

.vldInfoMain {
  width: auto;
  height: 100%;
  padding: 0 0 0 4px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.vldInfoTitle {
  width: 100%;
  height: 50%;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.vldInfoValue {
  width: 100%;
  height: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}
</style>